export default {
  name: 'table-column-spinner',
  props: {
    text: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      required: true
    },
    stylingClasses: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {}
}
